import { z } from 'zod';
import { TOKEN_MAP } from '../constants';

export const tokenSchema = z.object({
  id: z.string(),
  coinGeckoId: z.string(),
  issuer: z.string(),
  code: z.string(),
  description: z.string(),
  icon: z.string(),
});

export type Token = z.infer<typeof tokenSchema>;

/**
 * All the tokens ids such as xrp-mainnet, rlusd-mainnet, usdc-mainnet, xrp-testnet, rlusd-testnet, au1y-testnet, acgbt-testnet
 */
export type TokenId = (typeof TOKEN_MAP)[keyof typeof TOKEN_MAP][number]['id'];

/**
 * All the tokens codes such as XRP, RLUSD, USDC, AU1Y, ACGBT
 */
export type TokenCode = (typeof TOKEN_MAP)[keyof typeof TOKEN_MAP][number]['code'];
